<template>
    <b-container fluid class="p-0">
        <!-- Créé la liste des noeuds enfant de premier niveau -->
        <template v-for="childNode in ChildNodes">
            <dash-node v-bind:Node="childNode" :Action="Action"></dash-node>
        </template>
    </b-container>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import DashNode from './DashTree/DashNode.vue';
    import BaseTreeNode from '@/types/BaseTreeNode';

    /** Composant permettant la récupération de l'arborescence de l'administration des dashboards objets composés de type objet avec les dashboards existants */
    @Component({
        name: 'dash-tree',
        components: {
            DashNode
        }
    })
    export default class DashTree extends Vue {
        /** Droit disponible pour l'utilisateur en cours */
        @Prop()
        public Action!: string;

        @Prop()
        public ChildNodes!: BaseTreeNode[];
    }
</script>

<style scoped>
</style>